import { object, array, number, string } from '@gogame/schemas';

import {
  FILTER_COMPANIES,
  FILTER_DEPARTMENTS,
  FILTER_STUDIOS,
  FILTER_MANAGERS,
  FILTER_PAGES,
  FILTER_ACTIONS,
  FILTER_NETWORKS,
  FILTER_AFFILIATES,
  FILTER_APPLICATIONS,
  FILTER_SHOW,
} from '../constants';

export const filtersSchema = object({
  [FILTER_COMPANIES]: array(number()),
  [FILTER_DEPARTMENTS]: array(string()),
  [FILTER_STUDIOS]: array(number()),
  [FILTER_MANAGERS]: array(number()),
  [FILTER_PAGES]: array(number()),
  [FILTER_ACTIONS]: array(number()),
  [FILTER_NETWORKS]: array(number()),
  [FILTER_AFFILIATES]: array(number()),
  [FILTER_APPLICATIONS]: array(number()),
  [FILTER_SHOW]: array(number()).default([0]),
}).stripEmpty();

export const EMPTY_FILTERS = filtersSchema.default();
